/*import InfiniteAjaxScroll from '@webcreate/infinite-ajax-scroll';
import IASNoneLeftExtension from '@webcreate/infinite-ajax-scroll';
import IASHistoryExtension from '@webcreate/infinite-ajax-scroll';
import IASTriggerExtension from '@webcreate/infinite-ajax-scroll';
import IASPagingExtension from '@webcreate/infinite-ajax-scroll';
*/
(function($) {
    //add Element Actions on elementor init
    $(window).on('elementor/frontend/init', function() {

        //add default video Handler and register for video.kundp skin
        elementorFrontend.hooks.addAction( 'frontend/element_ready/video.kundp', function($scope){
            var video = elementorFrontend.elementsHandler.getHandlers( 'video.default' );
            video($scope);
        });

        elementorFrontend.hooks.addAction( 'frontend/element_ready/od_backgroundVideo.default', function($scope){

            var cookieVal = readCookie( 'cookieconsent_status' );
            var videoURL = $('.od_videocontainer').attr('data-autoplay');

            if(videoURL.length > 0 && cookieVal === 'dismiss'){
                $('.od_videocontainer iframe').attr('src', videoURL);
            }

            function readCookie(name) {
                var nameEQ = name + "=";
                var ca = document.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
                }
                return null;
            }

        });

        elementorFrontend.hooks.addAction( 'frontend/element_ready/od_referertitle.default', function($scope){
            //console.log($scope);
            //console.log(obj);

            var form            = $('elementor-form');
            var headline        = $('.referertitle');
            var refererHeadline = headline.data('title');
            var referertarget   = headline.data('targetid');
            var refererField    = $('#form-field-'+referertarget);

            refererField.val(refererHeadline);
        });

        elementorFrontend.hooks.addAction( 'frontend/element_ready/new_post_slider.default', function($scope) {

            var lang = $('html').attr('lang');
            if(lang.indexOf('de-DE') !== -1){
                var buttonText = 'Keine weiteren Posts';
                var motrePostsText = 'Weitere Posts';
            }else if(lang.indexOf('zh-hans') !== -1){
                var buttonText = '您已经浏览到结尾啦';
                var motrePostsText = '更多文章';
            }else{
                var buttonText = 'You have reached the end';
                var motrePostsText = 'More articles';
            }

            //console.log('Page language is: ', lang);

            var elementSettings = $scope.data('settings');

            //console.log(elementSettings);

            var postCount = parseInt(0);

            let ias = $.ias({
                container: '.od-postsslider__inner-wrap',
                item: '.od-postsslider__slide',
                pagination: '.od_paginate',
                next: '.next_posts_link',
            });

            ias.extension(new IASTriggerExtension({
                html: '<div class="od_load-more"><div class="btn btn-white-line">'+motrePostsText+'</div></div> ',

            }));
            ias.extension(new IASPagingExtension());
            ias.extension(new IASHistoryExtension({
                prev: 'a.page-numbers.previous',
            }));



            // Add a text when there are no more pages left to load

            $(document).ready(checkfirst(elementSettings));

            function checkfirst(elementSettings){
                if('highlight' in elementSettings){
                    if(postCount === 0 ){

                        var Posts = $('.od-postsslider__slide');
                        var firstPost = Posts[0];

                        $(firstPost).addClass('od-postsslider__slide--first');
                    }
                    postCount++;
                }
                if('pagination' in elementSettings){
                    // Add a text when there are no more pages left to load
                    ias.extension(new IASNoneLeftExtension({
                        html: '<div class="od_load-more"><div class="btn btn-white-line">'+buttonText+'</div></div> ',
                    }));
                }
            }
        });

        elementorFrontend.hooks.addAction( 'frontend/element_ready/od-locationslider.default', function($scope){
            var thisSwipterId = $scope.find('.swiper').attr('id');
            var swiper = new Swiper('#'+thisSwipterId, {
                slidesPerView: 'auto',
                spaceBetween: 10,
                loop: false,

                pagination: {
                    el: ".swiper-pagination",
                    type: "progressbar",
                },
                    navigation: {
                    nextEl: ".swiper-button-next--"+thisSwipterId,
                    prevEl: ".swiper-button-prev--"+thisSwipterId,
                },

                breakpoints: {
                    640: {
                      spaceBetween: 20,
                    },
                    768: {
                      spaceBetween: 20,
                    },
                    1025: {
                      spaceBetween: 20,
                    },
                },
            });
        });

        elementorFrontend.hooks.addAction( 'frontend/element_ready/onedotcarousel.default', function($scope){
            var elementSettings = $scope.data('settings');
            if(typeof elementSettings !== 'undefined'){
                var swiperOptions = {
                    grabCursor: true,
                    loop: 'yes' === elementSettings.loop,
                    loopedSlides: 2,
                    speed: elementSettings.speed,

                };
                swiperOptions.spaceBetween = getSpaceBetween();

                if ('yes' === elementSettings.show_arrows) {
                    swiperOptions.navigation = {
                        prevEl: '.case-study__swiper-button--prev',
                        nextEl: '.case-study__swiper-button--next'
                    };
                }

                if (elementSettings.pagination) {
                    swiperOptions.pagination = {
                        el: '.swiper-pagination',
                        type: elementSettings.pagination,
                        clickable: true
                    };
                }

                var swiper = new Swiper( $scope.find('.swiper-container') , swiperOptions);

                swiper.on('resize', function(){
                    swiper.params.spaceBetween = getSpaceBetween();
                });
            }

            function getSpaceBetween(){
                if($(window).width() > 1024){
                    return elementSettings.space_between.size;
                }else if($(window).width() > 768){
                    return elementSettings.space_between_tablet.size;
                }else{
                    return elementSettings.space_between_mobile.size;
                }
            }
        });

        elementorFrontend.hooks.addAction( 'frontend/element_ready/form.default', function($scope){
            $scope.find('input, textarea').focus(function(e) {
                var name = $(this).attr('id');
                if ($(this).val()) {
                    $('label[for="' + name + '"]').addClass('active');
                }
                if ($('label[for="' + name + '"]').length > 0) {
                    $('label[for="' + name + '"]').addClass('active');
                }
            });

            $scope.find('input, textarea').blur(function(e) {
                var name = $(this).attr('id');
                if ($('label[for="' + name + '"]').length > 0) {
                    $('label[for="' + name + '"]').removeClass('active');
                }
                if ($(this).val()) {
                    $('label[for="' + name + '"]').addClass('active');
                }
            });
        });

        elementorFrontend.hooks.addAction( 'frontend/element_ready/od_filterToggle.default', function($scope){

            var element = $('.od_filtertoggle');
            var btn = element.find('button');
            var collapseID = element.find('.collapse').attr('id');
            var less = $(btn).data('less');
            var more = $(btn).data('more');

            $('#'+collapseID).closest('.od_filtertoggle').find('button.btn-gradient-only').on('click', function(){

                if( $(this).html() === less ){
                    $(this).html(more);
                }else {
                    $(this).html(less);
                }
            });
        });

        elementorFrontend.hooks.addAction( 'frontend/element_ready/od_wishlistform.default', function($scope){
            var hiddeninput = $('#form-field-articleno');
            if(hiddeninput.length > 0) {
                $('tr.wishlist_item').each(function () {

                    var articlename = $(this).find('.product-name a').text();
                    hiddeninput.val(function (i, val) {
                        return val + (!val ? '' : ', ') + articlename;
                    });
                });
            }
        });

        elementorFrontend.hooks.addAction( 'frontend/element_ready/od_prodGallery.default', function($scope){

            console.log($scope);

            var galleryThumbs = new Swiper('.gallery-thumbs', {
                spaceBetween: 10,
                slidesPerView: 3,
                loop: false,
                freeMode: true,
                loopedSlides: 2, //looped slides should be the same
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            });
            var galleryTop = new Swiper('.gallery-top', {
                spaceBetween: 10,
                autoHeight: true,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                thumbs: {
                    swiper: galleryThumbs,
                },
            });

        });
        elementorFrontend.hooks.addAction( 'frontend/element_ready/od_togglebuttons.default', function($scope){
            var elementSettings = $scope.data('settings');
            var targetSelect = elementSettings.target_section;
            var activeTab = $('.muegge-tabmenu-list').find('.btn.nav-link.active[data-target]').attr('data-target');
            var inactiveTab = $(targetSelect + ' div[role="tabpanel"]' );

            inactiveTab.addClass('tabbed');
            $('#'+activeTab).addClass('visible');

            $('.muegge-tabmenu-list .btn.nav-link').on('click', function(){
                var target = $(this).data('target');

                $('.muegge-tabmenu-list .btn.nav-link').removeClass('active');
                $(this).addClass('active');
                inactiveTab.removeClass('visible');
                $('#'+target).addClass('visible');
            });
        });
    });
}(jQuery));
